export default {
  LIST_FETCHED: 'DONATIONS_FETCHED',
  LIST_LOAD: 'DONATIONS_LOAD',
  ITEM_DETAIL: 'DONATIONS_DETAIL',
  BUTTON_LOAD: 'DONATIONS_BUTTON_LOAD',
};
